import { postData } from '../utils/ajax-utils';
import { getData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initNotificationsPreferences(): void {
    const $notificationsPreferencesContainer = document.querySelectorAll<HTMLElement>('.js-notifs-form');
    $notificationsPreferencesContainer.forEach($container => {
        new NotificationsPreferences($container);
    });
    
}

class NotificationsPreferences {
    $el: HTMLElement | null | undefined;
    $alertSuccess: HTMLElement | null | undefined;
    $alertError: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$alertSuccess = $el?.querySelector('.alert.success');
        this.$alertError = $el?.querySelector('.alert.error');
        this.init();
    }

    init(): void {
        this.$el?.addEventListener('submit', (evt) => {
            evt.preventDefault();
            const formData = new URLSearchParams();
            formData.append('action', 'ajax_save_notifications_preferences');
            const checkboxes = this.$el?.querySelectorAll('input[type="checkbox"]');

            if (checkboxes) {
                checkboxes.forEach((checkbox) => {
                    const name = (checkbox as HTMLInputElement).name;
                    const isChecked = (checkbox as HTMLInputElement).checked;
                    formData.append('notifications['+name+']', String(isChecked));
                });

                postData(script_var.ajax_url, formData).then(response => {
                    let alertElement: HTMLElement | null;

                    if (response.success) {
                        alertElement = this.$alertSuccess || null;
                    } else {
                        alertElement = this.$alertError || null;
                    }
                    
                    if (alertElement instanceof HTMLElement) {
                        alertElement?.classList.remove('hidden');

                        setTimeout(() => {
                            alertElement?.classList.add('hidden');
                            
                            if (response.success) {
                                // Permet de synchroniser en ajax la popin de préférence & le formulaire sur le profil si soumission depuis cette page
                                const allNotificationsPreferencesForm = document.querySelectorAll('.js-notifs-form');
                                allNotificationsPreferencesForm.forEach((form) => {
                                    if (form !== this.$el) {
                                        getData(script_var.ajax_url, {
                                            action: 'ajax_get_notifications_preferences',
                                        }).then(response_notifications_preferences => {
                                            if (response_notifications_preferences.success) {
                                                if (form.parentElement) {
                                                    form.parentElement.innerHTML = response_notifications_preferences.data.html;
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        }, 4000);
                    }
                });
            }
        });
    }
}


